import { render, staticRenderFns } from "./ModalNewGroup.vue?vue&type=template&id=28e76d4c&"
import script from "./ModalNewGroup.vue?vue&type=script&lang=js&"
export * from "./ModalNewGroup.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports